import { UserDetails } from '@coach-bot/data-access/shared/models';
import { getGraphQLApiKey, getGraphQLEndpoint } from '@environment/utils/graphql';
import { withRetry } from '@shared/http/utils/with-retry';
import { GET_USER_DETAILS_BY_EMAIL_QUERY } from '../queries';

const GET_USER_DETAILS_BY_EMAIL_MAX_RETRY = 3;

export class InitialUserDetailsService {
  async getUserDetailsByEmail(email: string): Promise<UserDetails> {
    try {
      const response = await fetch(getGraphQLEndpoint(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': getGraphQLApiKey(),
        },
        body: JSON.stringify({
          query: GET_USER_DETAILS_BY_EMAIL_QUERY.replace('$email', email),
        }),
      });
  
      const jsonResponse = await response.json();
  
      if (response.status === 200 && !!jsonResponse && !jsonResponse.errors) {
        return jsonResponse.data?.getUserDetailsByEmail as UserDetails;
      } else {
        console.error('Error in API response: ', jsonResponse?.errors || response);
        const errorMessages: string | undefined = jsonResponse?.errors?.map((error: any) => error.message).join('; ');
        throw new Error(`API response is not correct. Status: ${response.status}. Errors: ${errorMessages}`);
      }
    } catch (error) {
      throw new Error(`getUserDetailsByEmail failed: ${error}`);
    }
  }

  async getUserDetailsByEmailWithRetry(email: string): Promise<UserDetails | null> {
    let userDetails: UserDetails | null = null;
    try {
      userDetails = await withRetry(
        async () => this.getUserDetailsByEmail(email),
        GET_USER_DETAILS_BY_EMAIL_MAX_RETRY,
        true
      );
    } catch (error) {
      // In case we cannot load user details, new extension UI won't be displayed, but tracking data will work as usual
      // based on Chrome profile email.
      console.error('Error loading user details: ', error);
    }
    return userDetails;
  }
}
